export default __webpack_public_path__ + "static/media/cryptocoins.413a26ec.woff";